import React, { useEffect, useState } from "react";
import _ from "lodash";
import moment from "moment";
import { EVENT_PLANNING_PEAK_DAYS_ORDER } from "../../../plannerConfig";
import { TableCell } from "./styles";
import {
  MultiWeekPlannerMainContainer,
  AssumptionSummaryText,
  TableWrapper,
  VisualisationSection,
  TableSection,
  TableRow,
} from "../multiWeekStyles.common";
import Visualisation from "../../Visualisations";
import LoadSpinnerOverlay from "../../LoadSpinner";
import { PeakCartonCountContainer } from "../styles";
import { getLargestValuesForCols, asFormattedValue } from "../../../helpers";

const PeakDaysOrderView = ({
  api,
  store,
  fromDate,
  toDate,
  fromDateFilter,
  toDateFilter,
  durationAggregator,
  selectedScenarios,
  activeFrontendFilters,
  filterData,
  appliedFilterForDashboard,
}) => {
  const { data, loadingQueue } = store[EVENT_PLANNING_PEAK_DAYS_ORDER];
  const [prefConfig, setPrefConfig] = useState("stackBar");

  const getPeakDayData = () => {
    const { get } = api;
    const buildSelectedScenariosString = selectedScenarios
      .map((scenario) => `scenario_id=${scenario.id}`)
      .join("&");
    if (fromDate && toDate) {
      get([EVENT_PLANNING_PEAK_DAYS_ORDER], {
        routeParams: {
          fromDate,
          toDate,
          fromDateFilter,
          toDateFilter,
          durationAggregator,
          scenarios: `${buildSelectedScenariosString}&`,
        },
      });
    }
  };

  useEffect(() => {
    getPeakDayData();
  }, [
    fromDate,
    toDate,
    fromDateFilter,
    toDateFilter,
    durationAggregator,
    selectedScenarios,
  ]);

  if (loadingQueue.length || _.isEmpty(data)) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <LoadSpinnerOverlay
          text="Peak Days Order Data Loading..."
          spinning={true}
        />
      </div>
    );
  }

  const parseDate = (date) => {
    if (!moment.isDate(date)) {
      return date;
    }
    const parsedDate = moment(date, "ddd DD/MM/YYYY").format("ddd DD/MM/YY");
    return parsedDate;
  };

  const onChangePrefConfig = (value) => {
    setPrefConfig(value);
  };

  const { CallOut, GraphA, TableA } = data;

  const largestValuesForCols = getLargestValuesForCols(TableA.data);

  const determineApplyFilter = (data) => {
    const returnedData =
      data && data.filter && Object.keys(data.filter).length > 0
        ? appliedFilterForDashboard(
            appliedFilterForDashboard(data, activeFrontendFilters, filterData),
            [],
            data.filter
          )
        : appliedFilterForDashboard(data, activeFrontendFilters, filterData);

    return returnedData;
  };

  const filteredGraphAData = determineApplyFilter(GraphA);

  return (
    <MultiWeekPlannerMainContainer>
      <div style={{ display: "flex", flex: 0.5 }}>
        <TableSection>
          <AssumptionSummaryText>{CallOut.title}</AssumptionSummaryText>
          <div style={{ marginBottom: "1em" }}>
            {CallOut.data.map(({ name, date, value, units, bold }) => (
              <PeakCartonCountContainer
                style={{ marginBottom: "1em" }}
                bold={bold}
                key={`${name}${value}`}
              >
                {`${name} - ${parseDate(date)} - ${asFormattedValue(
                  value
                )} ${units}`}
              </PeakCartonCountContainer>
            ))}
          </div>
          <TableWrapper>
            <TableRow className="headers">
              <TableCell className="headercell">Week</TableCell>
              <TableCell className="headercell">Volume LY</TableCell>
              <TableCell className="headercell highlighted">
                Volume TY
              </TableCell>
              <TableCell className="headercell">OWR</TableCell>
            </TableRow>
            {TableA.data.map((dataRow) => (
              <TableRow key={dataRow.Week}>
                <TableCell>{dataRow.Week}</TableCell>
                <TableCell>{asFormattedValue(dataRow["LY Volume"])}</TableCell>
                <TableCell
                  bold={
                    largestValuesForCols["TY Volume"] === dataRow["TY Volume"]
                  }
                  className="highlighted"
                >
                  {asFormattedValue(dataRow["TY Volume"])}
                </TableCell>
                <TableCell>{dataRow["OWR"]}</TableCell>
              </TableRow>
            ))}
          </TableWrapper>
        </TableSection>
      </div>
      <div style={{ display: "flex", flex: "1" }}>
        <VisualisationSection>
          <Visualisation
            data={filteredGraphAData}
            display={filteredGraphAData.display}
            categories={filteredGraphAData.categories}
            onChangePrefConfig={onChangePrefConfig}
            prefConfig={prefConfig}
          />
        </VisualisationSection>
      </div>
    </MultiWeekPlannerMainContainer>
  );
};

export default PeakDaysOrderView;
